import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {itemsPerPage} from '@shared/helpers';
import {MAT_LEGACY_SELECT_CONFIG as MAT_SELECT_CONFIG} from '@angular/material/legacy-select';

@Component({
  selector: 'app-page-size-switcher',
  templateUrl: './page-size-switcher.component.html',
  styleUrls: ['./page-size-switcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageSizeSwitcherComponent implements OnInit {
  @Input() selectedSize: number | undefined;
  @Input() disabled = false;
  @Output() changePageSize = new EventEmitter<number>();

  public options = itemsPerPage;

  constructor() { }

  ngOnInit(): void {
  }

  public changeSize(size: number): void {
    this.changePageSize.emit(size);
  }
}
